module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }